import React from 'react'

interface AudioEmbedDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const AudioEmbedDT: React.FC<AudioEmbedDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M18.3337 10.8327V7.49935C18.3337 3.33268 16.667 1.66602 12.5003 1.66602H7.50033C3.33366 1.66602 1.66699 3.33268 1.66699 7.49935V12.4993C1.66699 16.666 3.33366 18.3327 7.50033 18.3327H12.5003" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.29199 5.2168L7.41699 13.1085" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.9248 5.2168L10.0498 13.1085" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.44141 7.84961H13.3331" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 10.4844H12.8917" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default AudioEmbedDT
